export default "__VITE_ASSET__08094791__"